import { render, staticRenderFns } from "./PredictionSelect.vue?vue&type=template&id=304da793&"
import script from "./PredictionSelect.vue?vue&type=script&lang=js&"
export * from "./PredictionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports